<script>  
  import Page from "../../components/Page.svelte";  
  import Saos from 'saos/src/Saos.svelte';
</script>

<Page>  
  <div class="about-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-4 col-sm-12 order-md-2 text-center mb-md-0 mb-4">
            <img src="img/images/elon_big.png" alt="dog coin" class="img-fluid"/>
        </div>
        <div class="col-lg-6 col-md-8 col-sm-12">
            <div class="common_home_section">
              <h2>About Us</h2>
              <p class="white_normal_p">Dogs of Elon is a young project that started in the name of a meme by developers
                and marketers with a vision. It quickly proved itself to be a brand known for
                charitable donations and community building. Although the original creators have
                since moved on, the true identity of the token has remained. We are a community-driven and charitable project that has proven capable of building amazing utilities.</p>
              <div class="btn_group width50 pt-lg-5">
                <a rel="noreferrer" href="/about/#tokenomics" class="fill_btn">Tokenomics</a>
                <a href="/about/#team" class="outline_btn">Meet the Team</a>
              </div>
            </div>
        </div>
        
      </div>
    </div>
  </div>

  <div class="statement_section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-12 mb-lg-0 mb-4">
          <div class="common_home_section mission_vision">
            <h2>Mission Statement</h2>
            <p class="white_normal_p">Our mission is rather simple - to build the biggest community of blockchain
              enthusiasts, builders, holders and meme connoisseurs. The world has often shown
              us how dark it can be, and through the past several years, a handful of brave
              individuals who stood against the grain have somehow created a community that
              still manages to thrive. That community is us.</p>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="common_home_section mission_vision">                
            <h2>Vision Statement</h2>
            <p class="white_normal_p">
              Our Vision is to create a kickass ecosystem to promote blockchain technology
              through memes, utility and collaboration. The best way to onboarding millions of
              people to help us achieve this goal takes three simple steps; Making sure everyone
              is involved in the community
            </p>               
          </div>
        </div>              
      </div>
    </div>
  </div>        
  <div class="tokenomics_section" id="tokenomics">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-6 text-center">
          <img src="img/images/tokenomix_img.svg" class="img-fluid"/>
        </div>
        <div class="col-lg-6 col-md-6">
          <div class="common_home_section ps-lg-5">
            <h2>Tokenomics</h2>
            <div class="tokenomics_data">
              <p><span>Max Supply:</span><span>1,000,000,000 DOE</span></p>
              <p><span>Circulating Supply</span><span>192,000,000 DOE</span></p>
              <p><span>Locked Incentives</span><span>7.5%</span></p>
              <p><span>Locked Staking Rewards</span><span>30%</span></p>
              <p><span>Liquidity</span><span>15%</span></p>
              <p><span>CEX Allocation</span><span>30%</span></p>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>

  <div class="team_section" id="team">
    <div class="container">
      <h2>Meet our Team</h2>
      <div class="team_card_outer">
        <div class="team_card_content">
          <div class="team_card">
            <img class="avatar" src="img/images/team/cp.png" alt="icon"/>
            <p>Crypto President</p>
            <span>Project Lead</span>
            <div class="card_social_link">              
              <a href="https://t.me/thecryptopresident">
                <img class="normal_social" src="img/images/telegram_small.svg"/>
                <img class="hover_socail" src="img/images/telegram_hover.svg"/>
              </a>
              <a href="https://discordapp.com/users/929377112840888350/">
                <img class="normal_social" src="img/images/discord_small.svg"/>
                <img class="hover_socail" src="img/images/discord_hover.svg"/>
              </a>
            </div>
          </div>
        </div>
        <div class="team_card_content">
          <div class="team_card">
            <img class="avatar" src="img/images/team/crypdoebags.jpg" alt="icon"/>
            <p>CrypDOEbags</p>
            <span>Director of Communications</span>
            <div class="card_social_link">
              <a href="https://t.me/crypdoebags">
                <img class="normal_social" src="img/images/telegram_small.svg"/>
                <img class="hover_socail" src="img/images/telegram_hover.svg"/>
              </a>
              <a href="https://twitter.com/crypDOEbags">
                <img class="normal_social" src="img/images/twitter_small.svg"/>
                <img class="hover_socail" src="img/images/twitter_hover.svg"/>
              </a>
            </div>
          </div>
        </div>
        <div class="team_card_content">
          <div class="team_card">
            <img class="avatar" src="img/images/team/danny.png" alt="icon"/>
            <p>Danny</p>
            <span>Head of Marketing</span>
            <div class="card_social_link">
              <a href="https://t.me/JustDanny21">
                <img class="normal_social" src="img/images/telegram_small.svg"/>
                <img src="img/images/telegram_hover.svg"/>
              </a>
              <a href="https://twitter.com/dogs_elon">
                <img class="normal_social" src="img/images/twitter_small.svg"/>
                <img class="hover_socail" src="img/images/twitter_hover.svg"/>
              </a>
            </div>
          </div>
        </div>
        <div class="team_card_content">
          <div class="team_card">
            <img class="avatar" src="img/images/team/prash.jpg" alt="icon"/>
            <p>Prash</p>
            <span>Head of Development</span>
            <div class="card_social_link">
              <a href="https://t.me/prashcha">
                <img class="normal_social" src="img/images/telegram_small.svg"/>
                <img class="hover_socail" src="img/images/telegram_hover.svg"/>
              </a>
              <a href="https://twitter.com/prashdoe">
                <img class="normal_social" src="img/images/twitter_small.svg"/>
                <img class="hover_socail" src="img/images/twitter_hover.svg"/>
              </a>
            </div>
          </div>
        </div>
        <div class="team_card_content">
          <div class="team_card">
            <img class="avatar" src="img/images/team/brian.png" alt="icon"/>
            <p>Brian Harrison</p>
            <span>Game Developer</span>
             <div class="card_social_link">              
              <a href="https://t.me/BrianHarrison440">
                <img class="normal_social" src="img/images/telegram_small.svg"/>
                <img class="hover_socail" src="img/images/telegram_hover.svg"/>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>                      
</Page>


<style>
@keyframes -global-fadeInLeft {
  0% {
      opacity: 0;
      -webkit-transform: translate3d(-100%, 0, 0);
      transform: translate3d(-100%, 0, 0);
  }
  to {
      opacity: 1;
      -webkit-transform: translateZ(0);
      transform: translateZ(0);
  }
}
@keyframes -global-fadeInRight {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(100%, 0, 0);
        transform: translate3d(100%, 0, 0);
    }
    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0);
    }
}
@-webkit-keyframes -global-zoomIn {
    0% {
        opacity: 0;
        -webkit-transform: scale3d(0.3, 0.3, 0.3);
        transform: scale3d(0.3, 0.3, 0.3);
    }
    50% {
        opacity: 1;
    }
}
.avatar {
  width: 153px;
height: 157px;
border-radius: 50%;
object-fit: cover;
}
.about-section{
  padding: 80px 0 130px 0;
}
.common_home_section .white_normal_p{
  color: #fff;
  font-style: normal;
}
.statement_section{
  padding: 150px 0;
}
.tokenomics_section{
  padding: 150px 0;
}
.tokenomics_data p{
  display: flex;
  justify-content: space-between;
  color: #fff;
  font-style: normal;
  margin-bottom: 8px;
}
.team_section{
  padding: 150px 0 15px 0;
}
.team_section h2{
  font-size: 48px;
  font-weight: 600;
  color: #93CDBF;
  margin-bottom: 50px;
}
.team_card_outer{
  display: flex;
  flex-wrap: wrap;
  
}
.team_card_outer{
  margin-left: -9px;
  margin-right: -9px;
}
.team_card_content{  
  width: 25%;
  padding-right: 9px;
  padding-left: 9px;
  margin-bottom: 30px;
}
.team_card{
  text-align: center;
  background-color: #1E2031;
  padding: 60px 0 50px 0;
}
.team_card p{
  font-size: 27px;
  font-weight: 600;
  margin: 36px 0 45px 0;
  color: #fff;
}
.team_card span{
  color: #A1A1A1;
  font-size: 17px;
  font-weight: 300;
}
.card_social_link{
  margin-top: 60px;
}
.card_social_link a:nth-child(2){
  margin-left: 40px;
}
.card_social_link a {
  color: #1E2031;
}    
.card_social_link a img{
  height: 55px;
}
.card_social_link a img:last-child{
  display:none;
}
.card_social_link a:hover img:last-child{
  display:inline-block;
}
.card_social_link a:hover img:first-child{
  display:none;
}
.mission_vision{
  background-color: #1E2031;
  padding: 50px;
  height: 100%;
}
@media (max-width:1300px){
  .team_section h2{
    font-size: 36px;
    margin-bottom: 40px;
  }
}
@media (max-width:1200px){
  .about-section{
    padding: 70px 0;
  }
  .statement_section{
    padding: 80px 0;
  }
  .tokenomics_section{
    padding: 80px 0;
  }
  .team_section{
    padding: 80px 0 15px 0;
  }
  .team_card_content{
    width: 33.33%;
  }
  .mission_vision{   
    padding: 30px;    
  }
}
@media (max-width:992px){
  .about-section{
    padding: 50px 0;
  }
  .statement_section{
    padding: 50px 0;
  }
  .tokenomics_section{
    padding: 50px 0;
  }
  .team_section{
    padding: 50px 0 15px 0;
  }  
  .team_card{
    padding: 45px 0 40px 0;
  }
  .team_card>img{
    height: 120px;
  }
  .team_card p{
    font-size: 24px;
    margin: 30px 0;
  }
  .card_social_link{
    margin-top: 40px;
  }
  .card_social_link a img{
    height: 42px;
  }
}
@media (max-width:768px){
  .team_card_content{
    width: 50%;
  }
  .team_section h2{
    font-size: 30px;
    margin-bottom: 25px;
  }
}
@media (max-width:576px){
  .about-section{
    padding: 30px 0;
  }
  .statement_section{
    padding: 30px 0;
  }
  .tokenomics_section{
    padding: 30px 0;
  }
  .team_section{
    padding: 30px 0 15px 0;
  }  
  .team_card_content{
    width: 100%;
  }
  .avatar {
    height: 120px;
    width: 120px;
  }
  .team_card p {
    font-size: 22px;
    margin: 20px 0;
  }
  .card_social_link {
    margin-top: 25px;
  }
  .team_card_content{
    margin-bottom: 20px;
  }
  .mission_vision{   
    padding: 15px;    
  }
}
</style>
